<template>
  <div>
    <NavMenu />

    <div class="page-content">
      <div class="construction-notice">Promotion management is still under construction. In the meantime, please use the <a href="https://alightcreative.com/admin" target="_blank">old promo code manager</a>.</div>
    </div>

  </div>
</template>

<script>

import NavMenu from '@/components/NavMenu.vue'

export default {
  name: 'Promotions',
  components: { NavMenu }
}
</script>